(function () {
  const enhancer = document.querySelector("[data-sc-offer-concept-enhancer]");
  if (!enhancer) return;

  const feedingSpoonImage = enhancer.dataset.feedingSpoonImage || "";
  const moneyFormatter = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
  const experimentEndsAt = Date.parse("2026-09-03T00:00:00Z");
  const challengerAllocation = 0.10;

  const formatPrice = (value) => {
    if (typeof value === "string" && value.trim().startsWith("$")) return value.trim();
    return moneyFormatter.format((Number(value) || 0) / 100);
  };

  const publishOfferEvent = (eventName, detail) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...detail });
    document.dispatchEvent(new CustomEvent(eventName, { detail }));
  };

  const setLineProperty = (form, name, value) => {
    let input = form.querySelector(`input[name="properties[${name}]"]`);
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = `properties[${name}]`;
      form.appendChild(input);
    }
    input.value = value;
  };

  const boxDefaultAssignment = (form) => {
    const experimentRoot = form.closest("[data-sc-box-default-experiment]");
    if (!experimentRoot) return { boxCount: 1, variant: "standard_default" };

    const experiment = experimentRoot.dataset.scBoxDefaultExperiment || "two-box-v1";
    const forced = new URLSearchParams(window.location.search).get("sc_box_default");
    const storageKey = `sc_box_default:${experiment}`;
    let variant = forced === "2" ? "two_box" : forced === "1" ? "one_box" : "";

    if (!variant) {
      try {
        variant = window.sessionStorage.getItem(storageKey) || "";
      } catch (error) {}
    }
    if (!forced && Date.now() >= experimentEndsAt) variant = "one_box";
    if (!variant) variant = Date.now() >= experimentEndsAt || Math.random() >= challengerAllocation ? "one_box" : "two_box";

    if (!forced) {
      try {
        window.sessionStorage.setItem(storageKey, variant);
      } catch (error) {}
    }

    experimentRoot.dataset.scBoxDefaultVariant = variant;
    return { boxCount: variant === "two_box" ? 2 : 1, experiment, variant, forced: Boolean(forced) };
  };

  const cartBumpAssignment = (form) => {
    const experimentRoot = form.closest("[data-sc-cart-bump-experiment]");
    if (!experimentRoot) return {};

    const experiment = experimentRoot.dataset.scCartBumpExperiment || "second-box-v1";
    const forced = new URLSearchParams(window.location.search).get("sc_cart_bump");
    const storageKey = `sc_cart_bump:${experiment}`;
    let variant = forced === "1" ? "bump" : forced === "0" ? "holdout" : "";

    if (!variant) {
      try {
        variant = window.sessionStorage.getItem(storageKey) || "";
      } catch (error) {}
    }
    if (!forced && Date.now() >= experimentEndsAt) variant = "holdout";
    if (!variant) variant = Date.now() >= experimentEndsAt || Math.random() >= challengerAllocation ? "holdout" : "bump";

    if (!forced) {
      try {
        window.sessionStorage.setItem(storageKey, variant);
      } catch (error) {}
    }

    experimentRoot.dataset.scCartBumpVariant = variant;
    return { experiment, variant, forced: Boolean(forced) };
  };

  const getCards = (form) => Array.from(form.querySelectorAll(".offer-card, .pg-package-card"));

  const getBoxCount = (card, index) => {
    const explicit = Number(card.dataset.boxes || 0);
    if (explicit) return explicit;
    const source = card.dataset.boxLabel || card.textContent || "";
    const parsed = Number(source.match(/\b([123])\s*(?:box|boxes)/i)?.[1] || 0);
    return parsed || index + 1;
  };

  const getSubscriptionInput = (form) => (
    form.querySelector('input[name="purchase_option"][value="subscription"]')
    || form.querySelector('input[name="properties[Purchase option]"][value="Subscribe & Save"]')
  );

  const getOneTimeInput = (form) => (
    form.querySelector('input[name="purchase_option"][value="one-time"]')
    || form.querySelector('input[name="properties[Purchase option]"][value="One-Time Purchase"]')
  );

  const isSubscriptionMode = (form) => {
    const subscriptionInput = getSubscriptionInput(form);
    const oneTimeInput = getOneTimeInput(form);
    if (subscriptionInput) return subscriptionInput.checked;
    return !oneTimeInput?.checked;
  };

  const cardIsSelected = (card) => Boolean(card.querySelector('input[name="id"]')?.checked);

  const getSubscriptionSavings = (card) => (
    card.dataset.subscriptionTotalSavingsRate
    || card.dataset.subscriptionSavingsRate
    || card.dataset.pgSubscriptionSavings
    || 0
  );

  const getOneTimeSavings = (card) => card.dataset.oneTimeSavingsRate || 0;

  const getSubscriptionPrice = (card) => (
    card.dataset.subscriptionPrice
    || card.dataset.pgSubscriptionPrice
    || card.querySelector("[data-card-price], [data-sc-card-price], [data-pg-price]")?.textContent
    || ""
  );

  const inclusionMarkup = (boxCount) => `
    <div class="concept-inclusions">
      <div class="concept-inclusions-list">
        <span class="concept-inclusion-row">
          <span class="concept-inclusion-check" aria-hidden="true">✓</span>
          <span class="concept-inclusion-copy" data-sc-card-savings-copy></span>
        </span>
        <span class="concept-inclusion-row concept-subscription-only">
          <span class="concept-inclusion-check" aria-hidden="true">✓</span>
          <span class="concept-inclusion-copy">Ships every ${boxCount * 30} days</span>
        </span>
        <span class="concept-inclusion-row concept-subscription-only">
          <span class="concept-inclusion-check" aria-hidden="true">✓</span>
          <span class="concept-inclusion-copy">Pause, skip, or cancel anytime</span>
        </span>
        <span class="concept-inclusion-row">
          <span class="concept-inclusion-check" aria-hidden="true">✓</span>
          <span class="concept-inclusion-copy">90-day money-back guarantee</span>
        </span>
        <section class="concept-gift-panel concept-subscription-only" aria-label="First-order subscriber welcome gifts">
          <header class="concept-gift-heading">
            <span class="concept-gift-heading-copy">
              <strong>Your Free Gifts</strong>
              <small>First subscription order only</small>
            </span>
          </header>
          <div class="concept-gift-list">
            <article class="concept-gift-card">
              <span class="concept-gift-visual concept-spoon-visual">
                <img src="${feedingSpoonImage}" alt="Navy and yellow HydraFlow feeding spoon and sachet squeezer" width="96" height="96" loading="lazy">
                <span class="concept-gift-price"><s>$14.99</s><b>FREE</b></span>
              </span>
              <strong class="concept-gift-name">HydraFlow™ Feeding Spoon</strong>
            </article>
            <article class="concept-gift-card">
              <span class="concept-gift-visual concept-plan-visual">
                <span class="concept-plan-sheet" aria-hidden="true">
                  <span class="concept-plan-cat">🐱</span>
                  <i></i><i></i><i></i><b>✓</b>
                </span>
                <span class="concept-gift-price"><s>$29.99</s><b>FREE</b></span>
              </span>
              <strong class="concept-gift-name">Personalized Hydration Plan</strong>
            </article>
          </div>
        </section>
      </div>
    </div>
  `;

  const decorateForm = (form) => {
    const cards = getCards(form);
    if (!cards.length || form.dataset.scOfferConceptReady === "true") return;

    form.dataset.scOfferConceptReady = "true";
    const scope = form.closest(".shopify-product-box, .pg-choose-box, #offer, .offer-panel, .cf-offer-panel") || form;
    scope.classList.add("concept-offer-scope");
    cards.forEach((card, index) => {
      const boxCount = getBoxCount(card, index);
      card.classList.add("concept-package-card");
      card.dataset.conceptBoxes = String(boxCount);

      let expanded = card.querySelector(".package-expanded, .concept-package-expanded");
      if (!expanded) {
        expanded = document.createElement("span");
        expanded.className = "concept-package-expanded";
        card.appendChild(expanded);
      }
      expanded.innerHTML = inclusionMarkup(boxCount);
    });

    const subscriptionInput = getSubscriptionInput(form);
    const fixedDefaultBoxes = Number(form.dataset.scDefaultBoxes || form.closest("[data-sc-default-boxes]")?.dataset.scDefaultBoxes || 0);
    const assignment = fixedDefaultBoxes
      ? { boxCount: fixedDefaultBoxes, variant: "fixed_default" }
      : boxDefaultAssignment(form);
    const bumpAssignment = cartBumpAssignment(form);
    const preferredCard = cards.find((card) => Number(card.dataset.conceptBoxes) === assignment.boxCount) || cards[0];
    const preferredInput = preferredCard?.querySelector('input[name="id"]');

    if (subscriptionInput && !subscriptionInput.disabled) {
      subscriptionInput.checked = true;
      subscriptionInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
    if (preferredInput && !preferredInput.disabled) {
      preferredInput.checked = true;
      preferredInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    if (assignment.experiment) {
      setLineProperty(form, "_sc_box_default_test", `${assignment.experiment}:${assignment.variant}`);
      if (assignment.forced) setLineProperty(form, "_sc_forced_qa", "true");
      publishOfferEvent("supercat_offer_experiment_view", {
        experiment: assignment.experiment,
        variant: assignment.variant,
        default_boxes: assignment.boxCount,
        challenger_allocation: challengerAllocation,
        experiment_ends_at: new Date(experimentEndsAt).toISOString(),
        forced_assignment: assignment.forced,
        page_path: window.location.pathname,
      });
    }
    if (bumpAssignment.experiment) {
      setLineProperty(form, "_sc_cart_bump_test", `${bumpAssignment.experiment}:${bumpAssignment.variant}`);
      publishOfferEvent("supercat_cart_bump_assignment", {
        experiment: bumpAssignment.experiment,
        variant: bumpAssignment.variant,
        challenger_allocation: challengerAllocation,
        experiment_ends_at: new Date(experimentEndsAt).toISOString(),
        forced_assignment: bumpAssignment.forced,
        page_path: window.location.pathname,
      });
    }

    const update = () => {
      const subscription = isSubscriptionMode(form);
      scope.classList.toggle("concept-one-time", !subscription);

      cards.forEach((card) => {
        const selected = cardIsSelected(card);
        card.classList.toggle("concept-selected", selected);
        const savingsCopy = card.querySelector("[data-sc-card-savings-copy]");
        if (savingsCopy) {
          savingsCopy.textContent = subscription
            ? `${getSubscriptionSavings(card)}% off regular price`
            : `Save ${getOneTimeSavings(card)}% today`;
        }
      });

      const selectedCard = cards.find(cardIsSelected) || cards[0];
      const subscriberNote = form.querySelector(".subscriber-note, [data-offer-note]");
      if (subscriberNote) {
        subscriberNote.textContent = subscription
          ? "Subscribe for the lowest price, automatic refills, and two welcome gifts with your first order."
          : "Choose the package size you want for a one-time purchase.";
      }

      const submitButton = form.querySelector(".product-submit, [data-pg-submit], [data-offer-submit]");
      if (submitButton && !submitButton.disabled && selectedCard) {
        submitButton.textContent = subscription
          ? `Subscribe & Get My Welcome Gifts — ${formatPrice(getSubscriptionPrice(selectedCard))}`
          : "Add To Cart — One-Time Purchase";
      }
    };

    form.addEventListener("change", (event) => {
      if (event.target.matches('input[name="purchase_option"], input[name="properties[Purchase option]"], input[name="id"]')) {
        window.setTimeout(update, 0);
      }
    });
    form.addEventListener("click", (event) => {
      if (event.target.closest(".purchase-option, .pg-purchase-toggle label, [data-offer-mode], .offer-card, .pg-package-card")) {
        window.setTimeout(update, 0);
      }
    });

    window.setTimeout(update, 0);
  };

  document.querySelectorAll("form.shopify-product-form, form.pg-pdp-form, form.hydraflow-product-form").forEach(decorateForm);

  document.querySelectorAll("#second-cta p").forEach((node) => {
    if (node.textContent.includes("Free shipping")) {
      node.textContent = "90-day money-back guarantee. Pause, skip, or cancel anytime. Shipping calculated at checkout.";
    }
  });
})();
